import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { ChargingParkUtilizationDto } from '../../../dto/chargingParkUtilizationDto';
import { ChargingStationsService } from '../../../services/entity/charging-stations.service';

@Component({
  selector: 'app-dashboard-charging-parks-utilization',
  templateUrl: './dashboard-charging-parks-utilization.component.html',
  styleUrls: ['./dashboard-charging-parks-utilization.component.scss']
})
export class DashboardChargingParksUtilizationComponent extends ComponentBase implements OnInit, OnDestroy {

  public className = 'DashboardChargingParksUtilizationComponent';
  private refreshSubscription: Subscription;

  parks: ChargingParkUtilizationDto[] = [];
  loading = true;
  isOperator = false;

  constructor(
    private chargingStationsService: ChargingStationsService,
    private activatedRoute: ActivatedRoute,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.authenticationService.userHasRole('Operator')) {
      this.isOperator = true;
    }
    this.refresh();
    this.refreshSubscription = interval(15000).subscribe(() => this.refresh());
  }

  ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  refresh(): void {
    const isInitialLoad = this.parks.length === 0;
    if (isInitialLoad) {
      this.loading = true;
    }
    const customerId = this.activatedRoute.parent?.snapshot?.params?.key;
    const req = this.isOperator && customerId != null
      ? this.chargingStationsService.getChargingStationsStatusPerGroupOfCustomer(+customerId)
      : this.chargingStationsService.getChargingStationsStatusPerGroup();
    req.subscribe({
      next: (result) => {
        this.parks = result ?? [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  getMax(p: ChargingParkUtilizationDto): number {
    const s = p.status;
    return (s?.online ?? 0) + (s?.charging ?? 0) + (s?.busy ?? 0) + (s?.offline ?? 0) + (s?.unregistered ?? 0);
  }

  getSegmentPercent(p: ChargingParkUtilizationDto, segment: 'online' | 'charging' | 'busy' | 'offline' | 'unregistered'): number {
    const max = this.getMax(p);
    if (max === 0) return 0;
    const count = p.status?.[segment] ?? 0;
    return Math.round((100 * count) / max);
  }

  getUtilizationPercent(p: ChargingParkUtilizationDto): number {
    const max = this.getMax(p);
    if (max === 0) return 0;
    const used = (p.status?.charging ?? 0) + (p.status?.busy ?? 0);
    return Math.round((100 * used) / max);
  }
}
